import { api } from '@/lib/api';

import type {
  ActiveAdResponse,
  AdEventPayload,
  AdEventResponse,
  AdEventType,
  AdPlacement,
} from '../types';

export const getActiveAdReq = async (placement: AdPlacement): Promise<ActiveAdResponse> => {
  try {
    const response = await api.get<ActiveAdResponse>('/api/v1/ads/active', {
      params: { placement },
    });

    return response.data;
  } catch (error) {
    console.error(`Failed to fetch active ad for placement "${placement}":`, error);
    return { campaign: null };
  }
};

export const postAdEventReq = async (
  campaignId: number,
  eventType: AdEventType,
  sessionId: string,
): Promise<AdEventResponse> => {
  const payload: AdEventPayload = { eventType, sessionId };

  try {
    const response = await api.post<AdEventResponse>(`/api/v1/ads/${campaignId}/events`, payload);
    return response.data;
  } catch (error) {
    console.error('Failed to track ad event:', error);
    return { success: false };
  }
};
